import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Button,
  Typography,
  TextField,
  Select,
  ListItemText,
  MenuItem,
} from '@mui/material';

import {
  LOC_OPEN as ACTIVE,
  LOC_INACTIVE as INACTIVE,
} from '../../lib/utils';

import ErrorMessage from '../common/error-message';

const styles = {
  flexRow: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    marginLeft: '10px',
    alignContent: 'space-around',
  },
  selected: {
    paddingTop: '8px',
    marginLeft: '2px',
    color: 'gray',
  },
  button: {
    width: '140px',
    fontSize: '12px',
  },
  error: {
    width: '300px',
    marginTop: '20px',
    float: 'right',
    marginRight: '20px',
  },
  content: {
    maxHeight: '480px',
    marginRight: '12px',
    paddingRight: '32px',
    maxWidth: '360px',
    overflowY: 'auto',
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
};

function BulkEditLocations({
  open, handleSave, handleClose, locationIds,
}) {
  const [error, setError] = useState(false);
  const [capacity, setCapacity] = useState('');
  const [status, setStatus] = useState('');
  const count = locationIds.length;

  const onSave = () => {
    if (!locationIds || locationIds.length < 1) {
      setError('Please select a location');
    } else if (!capacity && !status) {
      setError('Please select a hub capacity or status');
    } else {
      handleSave(locationIds, capacity, status);
    }
  };
  return (
    <Dialog
      open={open}
      maxWidth="lg"
      aria-labelledby="bulk-edit-locations-dialog-title"
      onClose={handleClose}
    >
      <DialogTitle id="bulk-edit-locations-dialog-title" style={styles.flexRow}>
        <Grid>
          <Typography variant="h6" component="span">Location</Typography>
          <Typography>
            {`Hubs Selected: ${count}`}
          </Typography>
        </Grid>
      </DialogTitle>
      <DialogContent sx={{ pb: 5 }}>
        <Grid style={styles.flexRow}>
          {error && (
            <Grid item xs={12}>
              <ErrorMessage errorMessage={error} />
            </Grid>
          )}
          {locationIds && locationIds.length > 0 && (
            <Grid item container style={styles.content} xs={12}>
              <Grid item xs={12}>
                <Typography style={styles.selected}>
                  Hub Capacity
                </Typography>
                <TextField
                  fullWidth
                  name="hubCapacity"
                  margin="dense"
                  type="number"
                  placeholder=""
                  value={capacity}
                  InputProps={{ inputProps: { min: 0 } }}
                  onChange={(e) => setCapacity(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography style={styles.selected}>
                  Hub Status
                </Typography>
                <Select
                  onChange={(e) => setStatus(e.target.value)}
                  value={status}
                  name="status"
                  fullWidth
                >
                  {[ACTIVE, INACTIVE].map((state) => (
                    <MenuItem dense key={state} value={state}>
                      <ListItemText primary={state} />
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          color="secondary"
          style={styles.button}
        >
          Cancel
        </Button>
        <Button
          onClick={onSave}
          color="primary"
          style={styles.button}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default BulkEditLocations;
